function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sdkLogger } from '../../logger';
import { setVideoContainerPlayoutRect } from './set-playout-rect-utils';
var domPlayerEngineLogger = sdkLogger.withContext('DomPlayerEngine');
export var DomPlayerEngine = /*#__PURE__*/ function() {
    "use strict";
    function DomPlayerEngine(playerEngineOptions) {
        _class_call_check(this, DomPlayerEngine);
        _define_property(this, "playerEngineOptions", void 0);
        _define_property(this, "playoutRect", void 0);
        this.playerEngineOptions = playerEngineOptions;
        if (!this.playerEngineOptions.videoHtmlContainerInfo) {
            throw new Error('DOM container element missing in Video HTML Container Info');
        }
        this.setPlayoutRect(this.getFullScreenPlayoutRect());
    }
    _create_class(DomPlayerEngine, [
        {
            key: "getElement",
            value: function getElement() {
                throw new Error('Trying to use react native component with a HTML player');
            }
        },
        {
            key: "disposeElement",
            value: function disposeElement() {
                throw new Error('Trying to use react native component with a HTML player');
            }
        },
        {
            key: "getCurrentPlayoutRect",
            value: function getCurrentPlayoutRect() {
                return this.playoutRect;
            }
        },
        {
            key: "getFullScreenPlayoutRect",
            value: function getFullScreenPlayoutRect() {
                return {
                    x: 0,
                    y: 0,
                    width: document.body.clientWidth,
                    height: document.body.clientHeight
                };
            }
        },
        {
            key: "setPlayoutRect",
            value: function setPlayoutRect(playoutRect) {
                var _this_playerEngineOptions;
                if ((_this_playerEngineOptions = this.playerEngineOptions) === null || _this_playerEngineOptions === void 0 ? void 0 : _this_playerEngineOptions.disablePlayoutRect) {
                    domPlayerEngineLogger.info('Ignoring playout rect since flag "disablePlayoutRect" is "true"');
                    return;
                }
                this.playoutRect = playoutRect;
                var videoHTMLContainer = this.playerEngineOptions.videoHtmlContainerInfo.videoHTMLContainer;
                setVideoContainerPlayoutRect(playoutRect, videoHTMLContainer);
            }
        }
    ]);
    return DomPlayerEngine;
}();

//# sourceMappingURL=dom-player-engine.js.map